import { ConversionDetails } from '@/types/transaction';

export interface ConversionRates {
  readonly client: number;
  readonly market: number;
  readonly effective: number | null;
}

const isDefined = <T>(value: T | null | undefined): value is T =>
  value !== null && value !== undefined;

export const getConversionRates = (
  conversionDetails: ConversionDetails | null | undefined,
): ConversionRates | null => {
  const { clientRate, marketExchangeRate, effectiveTransactionValue } = conversionDetails ?? {};

  if (!(isDefined<number>(clientRate) && isDefined<number>(marketExchangeRate))) {
    return null;
  }

  const rateValue = conversionDetails?.clientRate ?? conversionDetails?.marketExchangeRate;
  if (rateValue === null || rateValue === undefined) {
    return null;
  }

  const numericValue = Number(rateValue);
  if (isNaN(numericValue)) {
    return null;
  }

  return {
    client: numericValue,
    market: marketExchangeRate,
    effective: effectiveTransactionValue ?? null,
  };
};
